/* globals FormData */
import R from 'ramda'
import jwtDecode from 'jwt-decode'
import axios from '../axios'
import config from '../config'

export const loginUser = ({ email, password = null, linkedinId = null }) => {
  return axios.post(`${config.SERVER_URL}/user/login`, {
    email: email,
    password: password,
    linkedinId: linkedinId
  })
}

export const loginAdmin = (email, password) => {
  return axios.post(config.SERVER_URL + '/admin/login', {
    email: email,
    password: password
  })
}

export const resetPassword = email => {
  return axios.post(config.SERVER_URL + '/user/reset_password', {
    email: email
  })
}

export const validateToken = token => {
  if (!token) {
    return false
  } else {
    const decoded = jwtDecode(token)
    return decoded.exp < new Date().getTime() && !decoded.isAdmin
  }
}

export const validateAdminToken = token => {
  if (!token) {
    return false
  } else {
    const decoded = jwtDecode(token)
    return decoded.exp < new Date().getTime() && decoded.isAdmin
  }
}

export const registerUser = user => {
  return axios.post(config.SERVER_URL + '/user', user)
}

export const loggedUser = () => {
  return axios.get(config.SERVER_URL + '/user/me')
}

export const updateUser = user => {
  const userData = R.clone(user)
  delete user.picture
  delete user.preferences
  if (userData.picture && userData.picture.file) {
    let formData = new FormData()
    formData.append('id', userData.id)
    formData.append('file', userData.picture.file)
    return axios
      .post(`${config.SERVER_URL}/user/${userData.id}/picture`, formData, {
        headers: { 'content-type': 'multipart/form-data' }
      })
      .then(response => {
        return axios.put(`${config.SERVER_URL}/user/${user.id}`, user)
      })
      .catch(error => console.log(error))
  } else {
    return axios.put(`${config.SERVER_URL}/user/${user.id}`, user)
  }
}

export const requireAuth = (nextState, replace) => {
  let token = window.localStorage.getItem('hvbToken')
  if (!validateToken(token)) {
    replace({
      pathname: '/landing',
      state: { nextPathname: nextState.location.pathname }
    })
  } else {
    const decoded = jwtDecode(token)
    if (!decoded.user.nda) {
      window.location = '/landing/signup/ncnda?state=pending'
    }
  }
}

export const requireAdminAuth = (nextState, replace) => {
  if (!validateAdminToken(window.localStorage.getItem('hvbToken'))) {
    replace({
      pathname: '/admin-login',
      state: { nextPathname: nextState.location.pathname }
    })
  }
}

export const updatePassword = (currentPassword, newPassword) => {
  return axios.post(`${config.SERVER_URL}/user/change_password`, {
    currentPassword,
    newPassword
  })
}

export const resendConfirmationEmail = id => {
  return axios.post(`${config.SERVER_URL}/user/resend_activation`, { id })
}

export const validateUserCode = (id, code) => {
  return axios.post(`${config.SERVER_URL}/user/validate_code`, { id, code })
}

export const resendCode = id => {
  return axios.post(`${config.SERVER_URL}/user/resend_code`, { id })
}



// WEBPACK FOOTER //
// ./src/sources/AuthSources.js